module.exports = __webpack_public_path__ + "img/warranty.cf5e4039.svg";